import React from 'react';

import TrainIcon from 'views/components/icons/train-icon';

import AbstractMapMarker from '../abstract-map-marker';
import { Icon } from './index.styled';

const StationMarker = () => {
  return (
    <AbstractMapMarker>
      <Icon><TrainIcon /></Icon>
    </AbstractMapMarker>
  );
};

export default StationMarker;
